import { DomainConfig } from '../app/config/domain.config';

const apiBase = DomainConfig.isCorporateUAT ? 'https://dev.belair.in/' : DomainConfig.isCorporateLive ? 'https://dev.belair.in/' : 'https://air.belairtrip.com/';

export const environment = {
  production: true,
  // Cheaptickets.co.in: https://dev.cheaptickets.co.in/    {{Dev}}
  // Cheapticket.in: https://cheapticket.in/  {{Prod}}
  // Belairtrip.com: https://belairtrip.com/  https://air.belairtrip.com  {{Prod}}
  flightConfig: {
    apiUrl: apiBase,
    // apiUrl__: 'https://belairtrip.com/', //flight API URL
    imageUrl: `${apiBase}img/air_logos/`
  },
  hotelConfig: {
    apiUrl: 'https://api-dev.belhotel.in/b2c/'
  },
  carConfig: {
    apiUrl: ''
  },
  vISAConfig: {
    apiUrl: 'https://app.ivsource.com/' // VISA API URL
  },
  encKey: 'cheapTicket@cheapticket.in'
};
